import { render, staticRenderFns } from "./pre_btn_control_newfile.vue?vue&type=template&id=451cc1bc&scoped=true"
import script from "./pre_btn_control_newfile.vue?vue&type=script&lang=js"
export * from "./pre_btn_control_newfile.vue?vue&type=script&lang=js"
import style0 from "./pre_btn_control_newfile.vue?vue&type=style&index=0&id=451cc1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cc1bc",
  null
  
)

export default component.exports